import {testIdProps} from '@github-ui/test-id-props'
import type {HeaderGroup} from 'react-table'

import {useEnabledFeatures} from '../../../hooks/use-enabled-features'
import {AddColumnId} from '../column-ids'
import {getHeaderCellProps} from '../get-cell-styles'
import type {TableDataType} from '../table-data-type'
import {columnHeaderTestId} from '../test-identifiers'
import {useGetDragProps} from '../use-column-reordering'
import styles from './dummy-table-header-cell.module.css'
import {HeaderGridCell} from './header-grid-cell'
import {HeaderGridCellLayout} from './header-grid-cell-layout'

export const DummyHeaderCell = (props: {header: HeaderGroup<TableDataType>; height: number}) => {
  const {memex_get_table_props} = useEnabledFeatures()
  let {dragProps, key, ...headerProps} = props.header.getHeaderProps({
    style: {minWidth: props.header.width, height: props.height},
  })
  if (memex_get_table_props) {
    // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    dragProps = useGetDragProps(props.header)
    key = `header_${props.header.id}`
    headerProps = getHeaderCellProps({
      height: props.height,
      width: props.header.totalWidth,
      colSpan: props.header.totalVisibleHeaderCount,
    })
  }

  if (props.header.id === AddColumnId) {
    // workaround to ensure add column is rendered like our other header cells
    return (
      <HeaderGridCell
        key={key}
        tabIndex={-1}
        {...headerProps}
        {...dragProps.listeners}
        {...testIdProps(columnHeaderTestId(props.header.id))}
        ref={dragProps.setNodeRef}
      >
        <HeaderGridCellLayout className={styles.HeaderGridCellLayout}>
          {props.header.render('Header')}
        </HeaderGridCellLayout>
      </HeaderGridCell>
    )
  }

  return <div {...headerProps} role="cell" {...dragProps.listeners} ref={dragProps.setNodeRef} />
}

try{ DummyHeaderCell.displayName ||= 'DummyHeaderCell' } catch {}